/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClaimClaimIdRegisterPut200ResponseDto } from '../models/claim-claim-id-register-put-200-response-dto';


/**
 * the ClaCommandClaimRegister API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandClaimRegisterService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdRegisterPut
   */
  static readonly ClaimClaimIdRegisterPutPath = '/claim/{claimId}/register';

  /**
   * Register existing draft of the claim. As a result new claim will be created.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdRegisterPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRegisterPut$Response(params: {
    claimId: string;

    /**
     * Caller
     */
    caller: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClaimClaimIdRegisterPut200ResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandClaimRegisterService.ClaimClaimIdRegisterPutPath, 'put');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('caller', params.caller, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClaimClaimIdRegisterPut200ResponseDto>;
      })
    );
  }

  /**
   * Register existing draft of the claim. As a result new claim will be created.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdRegisterPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRegisterPut(params: {
    claimId: string;

    /**
     * Caller
     */
    caller: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClaimClaimIdRegisterPut200ResponseDto> {

    return this.claimClaimIdRegisterPut$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClaimClaimIdRegisterPut200ResponseDto>) => r.body as ClaimClaimIdRegisterPut200ResponseDto)
    );
  }

}
